import { render, staticRenderFns } from "./DocsCard.vue?vue&type=template&id=a48db552"
import script from "./DocsCard.vue?vue&type=script&lang=js"
export * from "./DocsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports